import React from 'react';
import {
  ScrollView,
  StyleSheet,
  Text,
  TouchableWithoutFeedback,
  View,
} from 'react-native';
import {noop} from 'lodash';

import Button from '/component/base/Button';
import BasePopover from '/component/base/Popover';

const styles = StyleSheet.create({
  scrollViewContainer: {
    maxHeight: 150,
  },
  buttonContainer: {
    paddingHorizontal: '25%',
    marginBottom: 20,
  },
});

interface DummyWithScrollProps {
  popoverClose: () => void;
}

const DummyWithScroll: React.FC<DummyWithScrollProps> = ({
  popoverClose = noop,
}) => {
  return (
    <BasePopover padded={true}>
      <View style={styles.buttonContainer}>
        <Button onPress={popoverClose}>Close Popover</Button>
      </View>
      <Text>This part is not scrollable</Text>
      <View style={styles.scrollViewContainer}>
        <ScrollView>
          <TouchableWithoutFeedback>
            <View>
              <Text>Scrollable content:</Text>
              <Text>has to be wrapped in:</Text>
              <Text>* A fixed height container containing</Text>
              <Text>* ScrollView containing</Text>
              <Text>* TouchableWithoutFeedback containing</Text>
              <Text>* A singular child component</Text>
              <Text>* A singular child component</Text>
              <Text>...</Text>
              <Text>Scrollable content:</Text>
              <Text>has to be wrapped in:</Text>
              <Text>* A fixed height container containing</Text>
              <Text>* ScrollView containing</Text>
              <Text>* TouchableWithoutFeedback containing</Text>
              <Text>* A singular child component</Text>
              <Text>* A singular child component</Text>
            </View>
          </TouchableWithoutFeedback>
        </ScrollView>
      </View>
    </BasePopover>
  );
};

export default DummyWithScroll;
